import gamevideojs from "./gamevideojs";
import "videojs-thumbnail-sprite";

export default class ClipsPlayer {
  constructor(options = {}) {
    this.player = null;

    this.options = Object.assign(
      {
        selector: "#clips-video-player" // Default selector
      },
      options
    );

    if ($(this.options.selector).length > 0) {
      // Clean up any problematic data attributes before initializing
      this.cleanupElementAttributes();
      
      this.player = gamevideojs(this.options.selector, this.options);

      let frames = $(this.options.selector).data("frames");
      if (frames && frames.length > 0) {
        let sprites = []
        let frameStart = 0;

        frames.forEach(frame => {
          sprites.push({
            url: frame,
            start: frameStart,
            duration: 320,
            width: 160,
            height: 90,
            interval: 2,
          });
    
          frameStart = frameStart + 320;
        });

        this.player.thumbnailSprite({
          sprites: sprites
        });
      }
    }
  }

  cleanupElementAttributes() {
    const element = $(this.options.selector)[0];
    if (element) {
      // Remove only problematic data attributes that might contain invalid JSON
      // Keep crop-related attributes that are essential for functionality
      const attributesToRemove = [
        'data-setup',
        'data-frames'
      ];
      
      attributesToRemove.forEach(attr => {
        if (element.hasAttribute(attr)) {
          element.removeAttribute(attr);
        }
      });
    }
  }

  pausePlayer() {
    if (this.player) {
      this.player.pause();
    }
  }

  dispose() {
    if (this.player != null) {
      this.player.dispose();
    }
  }
}
